module.exports = __webpack_public_path__ + "static/media/main_cover.c8870820.jpg";